<template>
  <transition name="lxm-transition-fade" mode="out-in">
    <div v-if="show" class="lxm-register-dialog-container">
      <div class="lxm-register-dialog">
        <div class="lxm-register-content">
          <div class="lxm-register-title"><span>恭喜</span> 您成功注册灵析</div>
          <div class="lxm-register-row" v-for="(item, index) in registerData" :key="index">
            <span class="lxm-register-text"><span v-if="item.isRequired" class="lxm-register-text-required"> * </span>{{ item.label }}</span>
            <div class="lxm-register-input-wrapper">
              <input
                v-model="item.value"
                class="lxm-register-input"
                type="text"
                :placeholder="item.placeholder"/>
              <div class="lxm-register-input-tip">{{ item.tip }}</div>
            </div>
          </div>
          <div class="lxm-register-button">
            <span @click="save">开启灵析</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="stylus">
  @import '../styles/index.styl'
  .lxm-register-dialog-container
    position: fixed
    z-index: 100
    width: 100%
    height: 100%
    top: 0
    left: 0
    background-color: rgba(0, 0, 0, 0.5)
    display: flex
    justify-content: center
    align-items: center
  .lxm-register-dialog
    flex 0 1 auto
    background-color: white
    border-radius: login-radius
    width: siz(350)
    padding: siz(25) siz(10) siz(25)
    text-align: left
  .lxm-register-title
    padding-bottom 26px
    font-size size-big
    font-weight bold
    text-align center
    // border-bottom 1px solid #ddd
    span
      color brand-primary
  .lxm-register-row
    display flex
    align-items flex-start
    margin 10px 0
  .lxm-register-text
    flex 0 1 40%
    padding-right 15px
    padding-top 5px
    text-align right
    font-size size
  .lxm-register-text-required
    color brand-primary
    vertical-align middle
  .lxm-register-input-wrapper
    flex 0 1 60%
    width 100%
  .lxm-register-input
    width 100%
    height 30px
    padding 0 4px
    border 1px solid #ddd
    border-radius 3px
    outline none
    font-size 12px
    -webkit-appearance: none
  .lxm-register-input-tip
    margin-top 4px
    font-size 12px
    color cloudy
  .lxm-register-button
    margin-top 30px
    text-align right
    span
      color #fff
      font-size: size
      border-radius: radius
      background-color: login-primary
      padding: siz(6) siz(16)
      height: siz(35)
      line-height: 1
</style>

<script>
  import * as aTypes from '@/store/action-types'
  export default {
    data: () => {
      return {
        registerData: [{
          label: '密码：',
          name: 'password',
          value: '',
          placeholder: '请输入账号密码',
          isRequired: true
        }, {
          label: '邀请机构/邀请人：',
          name: 'inviter',
          value: '',
          placeholder: '',
          tip: '请填写推荐您使用灵析的机构名称或者推荐人的名字'
        }]
      }
    },
    computed: {
      show () {
        return this.$store.state.login.isRegister
      }
    },
    methods: {
      save () {
        const body = {}
        this.registerData.forEach(item => {
          body[item.name] = item.value
        })
        this.$store.dispatch(aTypes.SAVE_LX_PASSWORD, { body })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmRegisterDialog.vue?1a61a18b